import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { License } from '../transactions-list/transactions-list.component';

export interface IntegrationDialogData {
  licenses: License;
  paymentID: string;
}

@Component({
    selector: 'app-integration-dialog',
    templateUrl: './integration-dialog.component.html',
    styleUrls: ['./integration-dialog.component.scss'],
    standalone: false
})
export class IntegrationDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<IntegrationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public tabsData: IntegrationDialogData) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
